import * as React from "react";
const SvgClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}><path fill="#BE8B45" d="M20 1.16 18.84 0 10 8.841 1.16 0 0 1.16 8.84 10 0 18.84 1.16 20 10 11.16 18.84 20 20 18.84 11.159 10z" /></svg>;
export default SvgClose;